import { render, staticRenderFns } from "./EditCancel.vue?vue&type=template&id=6430d1e2"
import script from "./EditCancel.vue?vue&type=script&lang=js"
export * from "./EditCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports